export enum ExecutionResourceType {
    Functions = 'functions',
    Sites = 'sites',
}
